import type { SVGProps } from "react";
export default function SvgQuestionnairesApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 154 188"
			{...props}
		>
			<foreignObject width={153.415} height={188.684} x={0} y={-0.683594}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1091_1334_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1091_1334)">
				<path
					fill="url(#paint0_linear_1091_1334)"
					fillOpacity={0.6}
					d="M113.379 48.651c-.143-3.377-1.617-6.898-4.489-9.124L82.915 19.406c.04.033.066.085.096.13-.03-.045-.055-.1-.096-.13-3.77-2.817-8.83-2.751-12.39-.013-2.209 1.713-25.895 20.041-25.993 20.14-2.963 2.411-4.366 5.854-4.497 9.123-.007-.168-.035-.334-.035-.503V88.52C40 93.755 44.245 98 49.481 98h54.452a9.48 9.48 0 0 0 9.481-9.48V48.152c0 .169-.03.332-.035.498"
				/>
				<path
					stroke="url(#paint1_linear_1091_1334)"
					d="M70.83 19.79c3.365-2.589 8.15-2.666 11.738-.017l.006.01.02.031.017-.011 25.973 20.12c2.735 2.12 4.158 5.492 4.296 8.75l.034-.001V88.52a8.98 8.98 0 0 1-8.981 8.98H49.481a8.98 8.98 0 0 1-8.981-8.98V48.676h.035c.126-3.145 1.475-6.447 4.313-8.757l.02-.016-.002.001.052-.042.205-.16.77-.6 2.738-2.123 8.412-6.516c6.206-4.806 12.676-9.814 13.785-10.675z"
				/>
			</g>
			<g filter="url(#filter1_ddddi_1091_1334)">
				<g opacity={0.45}>
					<path
						fill="white"
						fillOpacity={0.01}
						d="M101.192 14H52.226a4.79 4.79 0 0 0-4.79 4.79v53.811a4.79 4.79 0 0 0 4.79 4.791h48.966a4.79 4.79 0 0 0 4.791-4.79V18.79A4.79 4.79 0 0 0 101.192 14"
					/>
					<path
						stroke="url(#paint2_linear_1091_1334)"
						strokeOpacity={0.5}
						d="M52.226 14.5h48.967a4.29 4.29 0 0 1 4.291 4.291v53.81c0 2.37-1.922 4.29-4.291 4.29H52.226a4.29 4.29 0 0 1-4.29-4.29v-53.81a4.29 4.29 0 0 1 4.29-4.291Z"
					/>
				</g>
			</g>
			<foreignObject width={153.415} height={157.847} x={0} y={30.1494}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1091_1334_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_ddddi_1091_1334)">
				<path
					fill="url(#paint3_linear_1091_1334)"
					fillOpacity={0.6}
					d="M103.933 97.996H49.481c-5.236 0-9.481-4.245-9.481-9.48V48.148c0 4.854 2.794 9.275 7.18 11.358l25.042 11.89a10.46 10.46 0 0 0 8.97 0l25.042-11.89a12.57 12.57 0 0 0 7.18-11.358v40.366a9.48 9.48 0 0 1-9.481 9.481"
				/>
				<path
					stroke="url(#paint4_linear_1091_1334)"
					d="M40.5 53.161a13.07 13.07 0 0 0 6.466 6.797l25.04 11.89a10.96 10.96 0 0 0 9.401 0l25.041-11.89a13.07 13.07 0 0 0 6.466-6.795v35.353a8.98 8.98 0 0 1-8.981 8.98H49.481a8.98 8.98 0 0 1-8.981-8.98z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M95.12 33.321H58.293a2.034 2.034 0 1 1 0-4.069H95.12a2.034 2.034 0 1 1 0 4.069"
			/>
			<path
				fill="#FAFF00"
				d="M95.12 45.612H58.293a2.034 2.034 0 1 1 0-4.069H95.12a2.034 2.034 0 1 1 0 4.069"
			/>
			<path
				fill="#FAFF00"
				d="M95.12 57.902H58.293a2.034 2.034 0 1 1 0-4.069H95.12a2.034 2.034 0 1 1 0 4.069"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1091_1334"
					x1={76.8944}
					x2={76.8944}
					y1={17.3164}
					y2={98.0003}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1091_1334"
					x1={76.7072}
					x2={45.0735}
					y1={18.2}
					y2={82.1656}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1091_1334"
					x1={76.7092}
					x2={76.7092}
					y1={14}
					y2={77.392}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1091_1334"
					x1={76.8944}
					x2={76.8944}
					y1={48.1494}
					y2={97.9964}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_1091_1334"
					x1={76.7072}
					x2={62.9631}
					y1={48.6953}
					y2={93.6795}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<filter
					id="filter0_ddddi_1091_1334"
					width={153.415}
					height={188.684}
					x={0}
					y={-0.683594}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1334" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1334"
						result="effect2_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1334"
						result="effect3_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1334"
						result="effect4_dropShadow_1091_1334"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1334" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1334" />
				</filter>
				<filter
					id="filter1_ddddi_1091_1334"
					width={138.548}
					height={171.392}
					x={7.43506}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1334" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1334"
						result="effect2_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1334"
						result="effect3_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1334"
						result="effect4_dropShadow_1091_1334"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1334" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1334" />
				</filter>
				<filter
					id="filter2_ddddi_1091_1334"
					width={153.415}
					height={157.847}
					x={0}
					y={30.1494}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1334" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1334"
						result="effect2_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1334"
						result="effect3_dropShadow_1091_1334"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1334"
						result="effect4_dropShadow_1091_1334"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1334" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1334" />
				</filter>
				<clipPath id="bgblur_0_1091_1334_clip_path" transform="translate(0 .684)">
					<path d="M113.379 48.651c-.143-3.377-1.617-6.898-4.489-9.124L82.915 19.406c.04.033.066.085.096.13-.03-.045-.055-.1-.096-.13-3.77-2.817-8.83-2.751-12.39-.013-2.209 1.713-25.895 20.041-25.993 20.14-2.963 2.411-4.366 5.854-4.497 9.123-.007-.168-.035-.334-.035-.503V88.52C40 93.755 44.245 98 49.481 98h54.452a9.48 9.48 0 0 0 9.481-9.48V48.152c0 .169-.03.332-.035.498" />
				</clipPath>
				<clipPath id="bgblur_1_1091_1334_clip_path" transform="translate(0 -30.15)">
					<path d="M103.933 97.996H49.481c-5.236 0-9.481-4.245-9.481-9.48V48.148c0 4.854 2.794 9.275 7.18 11.358l25.042 11.89a10.46 10.46 0 0 0 8.97 0l25.042-11.89a12.57 12.57 0 0 0 7.18-11.358v40.366a9.48 9.48 0 0 1-9.481 9.481" />
				</clipPath>
			</defs>
		</svg>
	);
}
